<template>
  <section class="ScholarshipSearchResults">
    <h2 :class="{ Blink: loading }">Redirecting to Scholarship Search...</h2>
  </section>
</template>

<script setup lang="ts">

import { useSearchTypeRedirect } from "@app/composables/useSearchTypeRedirect";
import { SearchType } from "@domain/enums/SearchType";

const { loading } = useSearchTypeRedirect(SearchType.SCHOLARSHIP_SEARCH);
</script>

<style scoped lang="scss">
    .ScholarshipSearchResults {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        @include PaddingAreas(0.25, 0);
    }
    .Blink {
        animation: blink-animation 1s linear infinite;
    }

    @keyframes blink-animation {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
    }
</style>